// utils/version.js

import { MessageBox } from 'element-ui';

export async function isNewVersion() {
  console.log('版本检测 - 开始检查版本');

  try {
    // 使用 fetch API 替代 axios，更简单可靠
    const timestamp = Date.now();
    const url = `/version.json?t=${timestamp}`;

    console.log('版本检测 - 请求URL:', url);

    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('版本检测 - 服务器响应:', data);

    const version = data.version;
    const localVersion = localStorage.getItem('version');
    console.log('版本检测 - 远程版本:', version, '本地版本:', localVersion);

    // 检查版本是否变化
    if (localVersion && localVersion !== version) {
      console.log('版本检测 - 发现新版本，提示用户刷新');
      return new Promise((resolve) => {
        MessageBox.confirm('发现新的版本，请刷新页面后使用！', '系统提示', {
          confirmButtonText: '立即刷新',
          showCancelButton: false,
          closeOnClickModal: false,
          type: 'warning',
          showClose: false,
          customClass: 'message-box-confirm'
        })
          .then(() => {
            localStorage.setItem('version', version);
            window.location.reload(true);
            resolve(false); // 阻塞路由，因为会刷新页面
          })
          .catch(() => {
            resolve(false); // 阻塞路由
          });
      });
    } else {
      console.log('版本检测 - 版本相同或首次访问，更新本地版本');
      localStorage.setItem('version', version);
      return Promise.resolve(true); // 表示无版本更新，可以继续
    }
  } catch (error) {
    console.error('版本检测 - 错误:', error);
    console.error('版本检测 - 错误详情:', error.message);

    // 如果网络请求失败，返回true允许继续
    console.log('版本检测 - 网络请求失败，允许继续使用');
    return true;
  }
}

// 提供一个手动触发版本检查的方法，用于开发测试
export function checkVersion() {
  console.log('版本检测 - 手动触发版本检查');

  // 模拟版本变化用于测试
  const currentVersion = localStorage.getItem('version') || '1.0';
  const testVersion = currentVersion === '1.0' ? '1.1' : '1.0';

  console.log('版本检测 - 测试版本变化:', { current: currentVersion, test: testVersion });

  MessageBox.confirm(`测试版本检测！当前版本: ${currentVersion}, 模拟新版本: ${testVersion}。是否刷新页面？`, '版本检测测试', {
    confirmButtonText: '确认刷新',
    showCancelButton: true,
    closeOnClickModal: false,
    type: 'info',
  })
    .then(() => {
      localStorage.setItem('version', testVersion);
      console.log('版本检测 - 测试成功，版本已更新');
    })
    .catch(() => {
      console.log('版本检测 - 测试取消');
    });
}